import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  questionHeader: {
    backgroundColor: theme.palette.primary.light,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  answerSection: {
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
    borderRadius: 2,
    border: `1px solid ${theme.palette.paper.border}`,
  },
  themeText: {
    flex: 1,
    minWidth: 0,
  },
  statusBlock: {
    flexShrink: 0,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      alignItems: 'flex-start',
    },
  },
  statusChip: ({ chipColor }) => ({
    backgroundColor: chipColor,
    color: 'white',
    fontWeight: 600,
    textTransform: 'uppercase',
    flexShrink: 0,
  }),
  selectedAlternative: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  unselectedAlternative: {
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
